export const REQUEST_STATUSES = {
  NOT_INITIALIZED: undefined,
  PENDING: 'PENDING',
  SUCCESS: 'SUCCESS',
  CANCEL: 'CANCEL',
  ERROR: 'ERROR',
} as const;

type RequestStatusKeys = keyof typeof REQUEST_STATUSES;
export type RequestStatus = typeof REQUEST_STATUSES[RequestStatusKeys];

export const MEETING_DURATION = {
  SHORT: 'short',
  LONG: 'long',
} as const;
export const MEETING_DURATION_TIME = {
  SHORT: '15 minutes',
  LONG: '30 minutes',
} as const;

type MeetingDurationKeys = keyof typeof MEETING_DURATION;
export type MeetingDuration = typeof MEETING_DURATION[MeetingDurationKeys];

export const PATIENT_STATUSES = {
  RAS: 'RAS',
  PPC: 'PPC',
  PSG: 'PSG',
  DID_NOT_COME: 'Non venu',
} as const;

type PatientStatusKeys = keyof typeof PATIENT_STATUSES;
export type PatientStatus = typeof PATIENT_STATUSES[PatientStatusKeys];
